/* Interrupteur Day / Night : bascule la classe is-night sur la plaque
   (.product__media-wrapper). Le CSS fait le fondu de chaque photo vers
   sa version nuit (media « <alt>_dark ») et passe la plaque au noir. */
if (!customElements.get('inercy-night-toggle')) {
  customElements.define(
    'inercy-night-toggle',
    class InercyNightToggle extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.wrapper = this.closest('.product__media-wrapper') || this.closest('media-gallery');
        if (!this.button || !this.wrapper) return;

        // Les images de nuit sont chargees en paresseux : on les
        // precharge au premier survol pour que la bascule soit immediate.
        this.wrapper.addEventListener('pointerenter', () => this.preload(), { once: true });
        this.button.addEventListener('focus', () => this.preload(), { once: true });

        // Un changement de variante peut re-rendre la galerie : on
        // reprend l'etat courant de la plaque.
        this.button.setAttribute('aria-checked', String(this.wrapper.classList.contains('is-night')));

        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.preload();
          const night = this.button.getAttribute('aria-checked') !== 'true';
          this.wrapper.classList.toggle('is-night', night);
          // Deux interrupteurs (photo sur ordinateur, slider sur mobile) :
          // on les garde synchronises
          this.wrapper.querySelectorAll('inercy-night-toggle button').forEach((button) => {
            button.setAttribute('aria-checked', String(night));
          });
        });
      }

      preload() {
        this.wrapper.querySelectorAll('.product__media-night').forEach((image) => {
          image.loading = 'eager';
        });
      }
    }
  );
}
